export default function FormatLinkIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 20}
      height={height ? height : width ? width : 20}
      viewBox="0 96 960 960"
    >
      <path
        fill="currentColor"
        d="M280 790.131q-90.715 0-152.423-61.695-61.708-61.696-61.708-152.392t61.708-152.718Q189.285 361.304 280 361.304h124.173q16.707 0 28.158 11.784t11.451 28.565q0 16.782-11.451 28.108t-28.158 11.326H280q-58.304 0-96.609 38.304-38.304 38.305-38.304 96.609 0 58.304 38.304 96.609 38.305 38.304 96.609 38.304h124.173q16.707 0 28.158 11.501 11.451 11.502 11.451 28.283 0 16.782-11.451 28.108t-28.158 11.326H280Zm68.782-180.74q-14.672 0-24.031-9.41-9.36-9.41-9.36-24.156 0-14.747 9.36-23.982 9.359-9.234 24.031-9.234h262.436q14.672 0 24.031 9.41 9.36 9.41 9.36 24.156 0 14.747-9.36 23.982-9.359 9.234-24.031 9.234H348.782Zm207.61 180.74q-17.272 0-28.723-11.501-11.451-11.502-11.451-28.283 0-16.782 11.451-28.108t28.723-11.326H680q58.304 0 96.609-38.304 38.304-38.305 38.304-96.609 0-58.304-38.304-96.609-38.305-38.304-96.609-38.304H556.392q-17.272 0-28.723-11.501-11.451-11.502-11.451-28.283 0-16.782 11.451-28.391 11.451-11.608 28.723-11.608H680q90.715 0 152.706 61.978 61.99 61.978 61.99 152.674t-61.99 152.436Q770.715 790.131 680 790.131H556.392Z"
      />
    </svg>
  );
}
